export const list = {
  project_name: {
    name: '项目名称',
    key: 'project_name',
    width: '500'
  },
  customer_name: {
    name: '意向客户',
    key: 'customer_name',
  },
  joined_departments: {
    name: '参与团队',
    key: 'joined_departments',
  },
  important_members: {
    name: '项目骨干',
    key: 'important_members',
  },
  expected_investment: {
    name: '预计投入',
    key: 'expected_investment',
  },
  // project_start_time: {
  //   name: '项目周期',
  //   key: 'project_start_time'
  // },
  expected_benefit: {
    name: '预计效益',
    key: 'expected_benefit'
  }
};
